import React from 'react';

const SecuritiesHeader = ({ activeTab, fumId, onTabChange }) => {
  const handleTabClick = (tab) => {
    if (onTabChange) {
      onTabChange(fumId, tab);
    }
  };

  return (
    <div className="w-full px-1 py-3 border-b">
      <div className="w-full text-center bg-gray-800 text-white">
        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'fum' ? 'text-orange-500' : 'text-white hover:text-gray-300'
          }`}
          onClick={() => handleTabClick('fum')}
        >
          FUM
        </button>
        <span className="mx-2">|</span>
        
        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'securities' ? 'text-orange-500' : 'text-white hover:text-gray-300'
          }`}
          onClick={() => handleTabClick('securities')}
        >
          Securities
        </button>
        <span className="mx-2">|</span>

        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'investors' ? 'text-orange-500' : 'text-white hover:text-gray-300'
          }`}
          onClick={() => handleTabClick('investors')}
        >
          Investors
        </button>
        <span className="mx-2">|</span>

        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'security_register' ? 'text-orange-500' : 'text-white hover:text-gray-300'
          }`}
          onClick={() => handleTabClick('security_register')}
        >
          Register
        </button>
        <span className="mx-2">|</span>

        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'security_loan_note' ? 'text-orange-500' : 'text-white hover:text-gray-300'
          }`}
          onClick={() => handleTabClick('security_loan_note')}
        >
          Loan Note
        </button>
        <span className="mx-2">|</span>

        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'docs' ? 'text-orange-500' : 'text-white hover:text-gray-300'
          }`}
          onClick={() => handleTabClick('docs')}
        >
          Documents
        </button>
        <span className="mx-2">|</span>

        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'acquisition' ? 'text-orange-500' : 'text-white hover:text-gray-300'
          }`}
          onClick={() => handleTabClick('acquisition')}
        >
          Acquisition
        </button>
        <span className="mx-2">|</span>

        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'fees' ? 'text-orange-500' : 'text-white hover:text-gray-300'
          }`}
          onClick={() => handleTabClick('fees')}
        >
          Fees
        </button>
      </div>
    </div>
  );
};

export default SecuritiesHeader;
